/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: MyLabelNotConnected.tsx
 * Project: mle-client-n
 * Committed last: 2022/6/9 @ 1140
 * ---
 * Description:
 */

import { Button, Callout, Icon, Intent } from '@blueprintjs/core';

interface Props {
  onConnect: () => void;
}

export const MyLabelNotConnected = (props: Props) => {
  return (
    <Callout icon={ <Icon icon="warning-sign" size={ 25 }/> }
             intent={ Intent.WARNING } className="my-2">
      <div className="flex flex-row justify-between">
        <div>
          Nessun account MyLabel collegato, accedi per utilizzare
        </div>
        <div>
          <Button minimal intent={ Intent.WARNING }
                  onClick={ props.onConnect }>Collega</Button>
        </div>
      </div>
    </Callout>
  );
};